<template>
	<BaseCard
		:title="$t('notes').toString()"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
		:is-create-new="true"
		@clickCreate="clickCreate"
	>
		<table class="w-full">
			<tbody class="w-full">
				<tr
					v-for="note in notes"
					:key="note.id"
					class="tr odd:bg-white even:bg-gray-300 flex flex-grow flex-row gap-12 px-6 py-3"
					style="align-items: center"
				>
					<td class="flex flex-grow w-8/10" style="white-space: pre-line">
						{{ note.text }}
					</td>
					<td>
						{{ getGermanDate(new Date(note.created_at)) }}
					</td>
					<td>
						<button
							@click="clickEdit(note.id)"
							:title="$t('edit_note')"
							class="bg-sp btn block btn-overview-edit flex items-center justify-center text-white"
						>
							<font-awesome-icon :icon="['fas', 'edit']"></font-awesome-icon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</BaseCard>
</template>

<script>
import { DamagecasesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseCard from '@/components/damagecases/forms/BaseCard';
import { getGermanDate } from '@/plugins/Utils';

export default {
	name: 'Note',
	components: { BaseCard },
	props: {
		notes: {},
		disabled: {
			type: Boolean,
			default: false,
		},
		isToggleOpen: { type: Boolean, default: true },
	},
	data() {
		return {
			startValue: '',
		};
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('input', val);
			},
		},
	},
	methods: {
		getGermanDate,
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
		clickCreate() {
			this.$router.push({ name: 'damagecases.edit.notes' });
		},
		clickEdit(noteID) {
			this.$router.push({ name: 'damagecases.edit.notes', params: { noteId: noteID } });
		},
		save() {
			DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdNotePut(parseInt(this.$route.params.processId || this.$route.params.id), { note: this.model })
				.then(result => {
					this.$swal(this.$t('general.success').toString(), this.$t('note_saved').toString(), 'success');
					this.startValue = this.value;
				})
				.catch(error => {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
	},
};
</script>

<style scoped></style>
